export const ValidateMin = angular
    .module('app.directives.vlnMin', [])
    .directive('vlnMin', ($parse) => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, ele, attrs, ngModel) => {
                if (!attrs.vlnMin) {
                    throw new Error('Min attribute required for vln-min');
                }

                scope.$watch(attrs.vlnMin, (newVal, oldVal) => {
                    if (newVal !== oldVal) {
                        ngModel.$validate();
                    }
                });

                ngModel.$validators.min = (modelValue) => {
                    var other = $parse(attrs.vlnMin)(scope);

                    if (other != null && modelValue != null && modelValue !== '') {
                        return (modelValue >= other);
                    }

                    return true;
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/validateMin.directive.js